import { apiGet } from 'utils/request';
import HOST from 'utils/globals';

export const fetchOrganizationUnits = () =>
  apiGet(`${HOST}/organizationUnits/hierarchy`);
